import Cookies from "universal-cookie";
import { environment } from "../environment";

export const getCookie = (cookieName: string): string | null | undefined => {
  const cookies = new Cookies();
  return cookies.get(cookieName, { doNotParse: true });
};

export const clearCookies = (cookieNames: string[]) => {
  const cookies = new Cookies();
  cookieNames.forEach(cookieName => {
    cookies.remove(cookieName, {
      domain: environment.VITE_WEB_DOMAIN_COOKIE,
      path: "/",
    });
    cookies.remove(cookieName);
  });
};
